// @flow
import * as React from 'react';
import debounce from 'lodash/debounce';
import { FeedImpressionLogger, type TrackFeedImpression } from '@ta/tracking.impressions';
import MentionsInteractionContext from './MentionsImpressionContext';

type ExternalProps = {|
  children: React.Node,
|};

type Props = {|
  ...ExternalProps,
  trackFeedImpression: TrackFeedImpression,
|};

// A wrapper around a provider. Used so every context shares the same instance of the mutation function so it can be debounced
const MentionsImpressionProvider = ({ trackFeedImpression, children }: Props) => {
  // Can't trust Apollo to give back the same mutation function everytime. They all come from the same client, so use the one on mount
  const dispatcher = React.useCallback(debounce(trackFeedImpression, 500), []);
  return (
    <MentionsInteractionContext.Provider value={dispatcher}>
      {children}
    </MentionsInteractionContext.Provider>
  );
};

const MentionsImpressionProviderWithImpressionLogging = ({ children }: ExternalProps) => (
  <FeedImpressionLogger>
    {trackFeedImpression => (
      <MentionsImpressionProvider trackFeedImpression={trackFeedImpression}>
        {children}
      </MentionsImpressionProvider>
    )}
  </FeedImpressionLogger>
);

export default MentionsImpressionProviderWithImpressionLogging;
